import { render, staticRenderFns } from "./SurveyDetails.vue?vue&type=template&id=096c616a&scoped=true"
import script from "./SurveyDetails.vue?vue&type=script&lang=js"
export * from "./SurveyDetails.vue?vue&type=script&lang=js"
import style0 from "./SurveyDetails.vue?vue&type=style&index=0&id=096c616a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c616a",
  null
  
)

export default component.exports